import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { PublisherView } from "./PublisherView";
import { PublisherViewStore } from "../../store/PublisherViewStore";
import { useStore } from "../../../../hooks";

export const PublisherViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/publisher/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new PublisherViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [
            {
              id: "basicInformation",
              label: rootStore.langStore.groupPublisherBasicInformationLabel,
            },
            {
              id: "address",
              label: rootStore.langStore.groupPublisherAddressLabel,
            },
            {
              id: "legalInformation",
              label: rootStore.langStore.groupPublisherLegalInformationLabel,
            },
            {
              id: "systemDates",
              label: rootStore.langStore.groupPublisherSystemDatesLabel,
            },
          ],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <PublisherView publisherViewStore={store} />
      </PageLayout>
    </div>
  );
});
